var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccommodationHostel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coffee 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 19C1.71667 19 1.47917 18.9042 1.2875 18.7125C1.09583 18.5208 1 18.2833 1 18V5C1 4.71667 1.09583 4.47917 1.2875 4.2875C1.47917 4.09583 1.71667 4 2 4C2.28333 4 2.52083 4.09583 2.7125 4.2875C2.90417 4.47917 3 4.71667 3 5V14H11V8C11 7.45 11.1958 6.97917 11.5875 6.5875C11.9792 6.19583 12.45 6 13 6H19C20.1 6 21.0417 6.39167 21.825 7.175C22.6083 7.95833 23 8.9 23 10V18C23 18.2833 22.9042 18.5208 22.7125 18.7125C22.5208 18.9042 22.2833 19 22 19C21.7167 19 21.4792 18.9042 21.2875 18.7125C21.0958 18.5208 21 18.2833 21 18V16H3V18C3 18.2833 2.90417 18.5208 2.7125 18.7125C2.52083 18.9042 2.28333 19 2 19ZM7 13C6.16667 13 5.45833 12.7083 4.875 12.125C4.29167 11.5417 4 10.8333 4 10C4 9.16667 4.29167 8.45833 4.875 7.875C5.45833 7.29167 6.16667 7 7 7C7.83333 7 8.54167 7.29167 9.125 7.875C9.70833 8.45833 10 9.16667 10 10C10 10.8333 9.70833 11.5417 9.125 12.125C8.54167 12.7083 7.83333 13 7 13ZM13 14H21V10C21 9.45 20.8042 8.97917 20.4125 8.5875C20.0208 8.19583 19.55 8 19 8H13V14ZM7 11C7.28333 11 7.52083 10.9042 7.7125 10.7125C7.90417 10.5208 8 10.2833 8 10C8 9.71667 7.90417 9.47917 7.7125 9.2875C7.52083 9.09583 7.28333 9 7 9C6.71667 9 6.47917 9.09583 6.2875 9.2875C6.09583 9.47917 6 9.71667 6 10C6 10.2833 6.09583 10.5208 6.2875 10.7125C6.47917 10.9042 6.71667 11 7 11Z",
    fill: "#240b3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommodationHostel);
export default __webpack_public_path__ + "static/media/accommodation-hostel.18955a2cd9d0269a792083e3ac3bc199.svg";
export { ForwardRef as ReactComponent };